import { observer } from 'mobx-react-lite'
import React from 'react'
import { Outlet } from 'react-router'
import { PageLayout } from 'shared/ui'

import { ModalFullScreen } from 'shared/ui/ModalFullScreen/ModalFullScreen'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import { SettingsMenu } from 'pages/settings/layout/SettingsMenu'
import { SettingsMenuCollapseButton } from 'pages/settings/layout/SettingsMenuCollapseButton'

export const SettingsLayout = observer(() => {
  const { pageLayoutStore } = useSettingsContext()
  const rightContent = (
    <>
      <ModalFullScreen />
      <SettingsMenuCollapseButton />
      <Outlet />
    </>
  )

  return (
    <PageLayout
      leftContent={<SettingsMenu />}
      rightContent={rightContent}
      store={pageLayoutStore}
    />
  )
})
